import React, { useEffect, useState } from 'react';
import { ThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { Container, CssBaseline  } from '@material-ui/core';
import {
  HashRouter  as Router,
  Switch,
  Route  ,
  Redirect
} from "react-router-dom";
import Page1 from './Page1'
import Page2 from './Page2'
import { makeStyles } from '@material-ui/core/styles';
import { StoreProvider } from './store'
import bgImg from './h_scene.jpg'
import { doGet } from './AjaxRequests' 
import Swal from 'sweetalert2'
import _ from 'lodash'
import DateFnsUtils from '@date-io/date-fns'; // choose your lib
import {
  DatePicker,
  TimePicker,
  DateTimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import Result from './Result'
import './App.css'
import Button from '@material-ui/core/Button';
import queryString from 'query-string'
import Login from './Login'
import ApplyHistory from './ApplyHistory'
// import { CookiesProvider } from 'react-cookie';
import twLocale from "date-fns/locale/zh-TW"

const theme = createMuiTheme({
  spacing: 5,
  palette: {
    primary: {
      main: "#007bff",            
    },
    text:{
      white: "#FFF"
    },
    paper:{
      white: "rgba(255, 255, 255, 0.85)"
    }    
  }
});

const useStyles = makeStyles({
  root: {   
    backgroundImage: `url(${bgImg})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center bottom',
    backgroundSize: '100% 50%',        
    width: '100vw',
    height: '100vh',
    boxSizing: "border-box" 
  },
  mask:{
    width: '100vw',
    height: '100vh',
    background: 'linear-gradient(180deg, rgba(58,122,180,1) 50%, rgba(69,252,213,0.8) 100%)',
    boxSizing: "border-box",
    overflow: "auto"
  },
  container:{
    padding:theme.spacing(0,3)
  },
  logoutBtn:{
    position: 'fixed',
    right:'15px',
    top:'15px',
    
  }
});

function App(props) {

  const classes = useStyles(props);
  const [options, setOptions] = useState({});
  const [user, setUser] = useState(null)
  const [EMP2, setEMP2] = useState(false)

  useEffect(()=>{

    if(process.env.REACT_APP_HOST=="emr"){
      doGet('https://emr.kfsyscc.org/userinfo')
      .then((res)=>{
        if (res.status !== "true"){
          window.location.href = `https://emr.kfsyscc.org/signin/index.html?next=https://emr.kfsyscc.org/utils/covid_19_survey`
        }else{
          setUser(res.user)          
        }
      })
      .then(()=>{
        return getOptions()
      })      
    }else if(process.env.REACT_APP_HOST=="q"){
      getOptions()
    }   

  },[])

  
  const getOptions = () =>{
    let fetchUrl = "https://q.kfsyscc.org/surveyapi/get_TOCC_options"
    // let currentUrl = window.location.href 
    // if(currentUrl.includes('covid_19_survey_test')){
    //     fetchUrl = "https://q.kfsyscc.org/surveyapi/get_TOCC_options"
    // }

    doGet(fetchUrl)
    .then((data)=>{
      if(data.status){
        let raw_ctry_opts = _.cloneDeep(data.msg.options.country)
        let countryOptions = []
        // let none_opt = {value:"none", label:"否", level:"100"}
        // countryOptions.push(none_opt)
        _.map(raw_ctry_opts, (item, key)=>{
            if(item.countryCode != 'TW'){
              let opt = {}
              opt.value = item.countryCode;
              opt.label = `${item.countryName}`;
              opt.level = "1"
              countryOptions.push(opt)
            }            
        })

        // data.msg.options.reason = _.filter(_.cloneDeep(data.msg.options.reason), (o)=>{return o.value != 'AO'})

        data.msg.options.country = countryOptions

        setOptions(data.msg.options)
      }else{
        throw Error('連線錯誤')
      }      
    })
    .catch((e)=>{
      Swal.fire(e.message, "", "error")
    })   
  }

  const handleLogout=()=>{
    window.location.href =  `https://emr.kfsyscc.org/logout?next=/utils/covid_19_survey`
  }

  return (
    // <CookiesProvider>
    <StoreProvider>
      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={twLocale}>
        <ThemeProvider theme={theme}>
          <CssBaseline/>  
          <div className={classes.root}>  
            <div className={classes.mask}>
              {_.isEmpty(options)?null:
                <Container 
                  maxWidth='sm'
                  className={classes.container}
                >
                  <Router>
                    <Switch>
                      {/* <Route exact path="/" component={() => <Redirect to="/page1" />}/> */}
                      <Route exact path="/" component={(allprops) => <Login user={user} />}/>
                      <Route exact path="/applyHistory" component={(allprops) => <ApplyHistory {...allprops}/>}/>
                      <Route exact path="/page1" component={(allprops) => <Page1 options={options} user={user} {...allprops}/>}/>
                      <Route exact path="/page2" component={(allprops) => <Page2 options={options} user={user} {...allprops}/>}/>
                      <Route exact path="/result" component={Result}/>
                    </Switch>        
                  </Router>
                  {process.env.REACT_APP_HOST=="emr"?<Button variant="contained" color="secondary" className={classes.logoutBtn} onClick={handleLogout}>
                    登出
                  </Button>:null}  
                </Container> 
              } 
            </div>          
          </div>    
        </ThemeProvider>
      </MuiPickersUtilsProvider>
    </StoreProvider>
    // </CookiesProvider>
  );
}

export default App;
